// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import LinkButton from 'web-ssr/app/common/components/LinkButton';
import 'web-ssr/app/common/components/Button.scss';

import type { Node } from 'react';

import type { KindType } from 'web-ssr/app/common/types';

const bem = bemify('button');

type Props = {
  ariaLabel?: string,
  className?: string,
  children: Node,
  disabled?: boolean,
  type?: 'submit' | 'reset' | 'button',
  tag?: 'Link',
  kind?: KindType,
  onClick?: (e: SyntheticEvent<>) => void,
};

const Button = (props: Props) => {
  const {
    ariaLabel,
    children,
    className,
    kind,
    disabled,
    onClick,
    tag,
  } = props;

  if (tag === 'Link') {
    return (
      <LinkButton
        className={bem(className, toModifiers(kind))}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </LinkButton>
    );
  }

  const ariaProps = ariaLabel ? { 'aria-label': ariaLabel } : {};

  return (
    <button
      className={bem(className, toModifiers(kind))}
      disabled={disabled}
      onClick={onClick}
      {...ariaProps}
    >
      {children}
    </button>
  );
};

export default Button;
